var _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81709 0.925415H3.75499C3.03161 0.925415 2.44519 1.51183 2.44519 2.23521V14.7575C2.44519 15.4809 3.0316 16.0673 3.75499 16.0673H12.9994C13.7229 16.0673 14.3094 15.4808 14.3094 14.7573V5.40369L9.81709 0.925415Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.33801,
    y1: 9.60962,
    x2: 5.33801,
    y2: 13.7521,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.3866,
    y1: 7.89526,
    x2: 8.3866,
    y2: 13.752,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.4353,
    y1: 5.60986,
    x2: 11.4353,
    y2: 13.7521,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportOutline);
export default __webpack_public_path__ + "static/media/report-outline.d895d462ad8858cf1274043284d67229.svg";
export { ForwardRef as ReactComponent };